// extracted by mini-css-extract-plugin
export default {"skillsWrapper":"skills_skillsWrapper__AJwQn","skillLevel":"skills_skillLevel__Z1BWF"};